export const AUTH_TOKEN = "authToken";
export const APP_ID = "appID";
export const CONTACT_ID = "contactID";
export const LEAD_ID = "leadID";
export const Full_Name = "fullName";
export const Authorization_TOKEN ="tokenForCustomers"
export const JOURNEY_AUTH_TOKEN = "token";
export const LAST_ACTIVE_JOURNEY_SLIDE = "lastSlide";
export const EMPLOYEMENT_TYPE = "employmentType";
export const HAS_CO_APPLICANT = "hasCoApplicant";
export const CUSTOMER_AGE = "customerAge";
export const CUSTOMER_DETAILS = "customerDetails";
export const COOKIES_MAX_AGE = 172800; // 2 Days

// * Customer Input Values
export const MaxLoanAmount = 2500000;
export const MinLoanAmount = 10000;
export const genderOptions = [
  { name: "Male", value: "Male" },
  { name: "Female", value: "Female" },
];

export const qualificationExamples = [
  { name: "Select", value: "" },
  { name: "Undergraduate", value: "Undergraduate" },
  { name: "Graduate", value: "Graduate" },
  { name: "Post Graduate", value: "Post Graduate" },
  { name: "Other", value: "Other" },
];

export const coApplicantRelations = [
  { name: "Select", value: "" },
  { name: "Spouse", value: "Spouse" },
  { name: "Mother", value: "Mother" },
  { name: "Father", value: "Father" },
  { name: "Son", value: "Son" },
  { name: "Daughter", value: "Daughter" },
];

export const companyTypes = [
  { name: "Select", value: "" },
  { name: "Private Limited", value: "Private Limited" },
  { name: "Partnership Company", value: "Partnership Company" },
  { name: "Proprietor", value: "Proprietor" },
  { name: "Government/PSU", value: "Government/PSU" },
  { name: "LLP", value: "LLP" },
  { name: "Public", value: "Public" },
];

export const salaryCreditTypes = [
  { name: "Select", value: "" },
  { name: "Bank Transfer", value: "Bank Transfer" },
  { name: "By Cash", value: "By Cash" },
  { name: "By Cheque", value: "By Cheque" },
];

export const natureOfBusinessOptions = [
  { name: "Select", value: "" },
  { name: "Manufacturing", value: "Manufacturing" },
  { name: "Trading", value: "Trading" },
  { name: "Services", value: "Services" },
];
